import { Desktop } from "@/components/consultationForm/devices/desktop";
import { useCallback, useEffect, useState } from "react";
import { Mobile } from "@/components/consultationForm/devices/mobile";
import Bowser from "bowser";

export function ConsultationForm({ rootElement }: { rootElement: HTMLElement }) {
	const [isMobile, setIsMobile] = useState(false);
	const [browserInfo, setBrowserInfo] = useState({});

	useEffect(() => {
		const browser = Bowser.parse(window.navigator.userAgent);
		const info = `${browser.browser.name} ${browser.browser.version}, ${browser.os.name}, ${browser.platform.type}`;
		setBrowserInfo(info);
		if (info.includes("mobile") && window.innerWidth < 500) {
			setIsMobile(true);
		}
	}, [isMobile, browserInfo]);

	const renderComponent = () => {
		if (isMobile) {
			return <Mobile rootElement={rootElement} />;
		} else {
			return <Desktop rootElement={rootElement} />;
		}
	};

	return renderComponent();
}
